<app-page>
  <app-twitter-sync-settings></app-twitter-sync-settings>
  <!-- Bottom spacer for mobile -->
  <div *ngIf="this.globalVars.isMobile()" class="mt-40px"></div>
</app-page>
